import { Audience, ContainerEnvironment, DeploymentRing, Environment } from '@fluidx/office-fluid-types';

/**
 * Returns the corresponding deployment ring for the requested environment value,
 * giving preference to the Ring mapped to the "audience" field, followed by the
 * "ring" field for Unmapped audiences. Otherwise defaulting to Prod.
 */
export function getRingForEnvironment(environment: Environment | undefined): DeploymentRing {
  const ringFromAudience = getRingFromAudience(environment?.audience);
  if (ringFromAudience) {
    return ringFromAudience;
  }

  if (environment?.ring) {
    return environment.ring;
  }

  return 'Prod';
}

/**
 * Allows fetching a deployment ring from an audience. Exported for compatibility purposes with old code.
 */
export function getRingFromAudience(audience: Audience | undefined): DeploymentRing | undefined {
  switch (audience) {
    case 'Staging':
      return 'Staging';
    case 'Dogfood':
      return 'Dogfood';
    case 'Preview':
    case 'Microsoft':
    case 'Production':
      return 'Prod';
    case 'GCC':
    case 'GCC-High':
    case 'DoD':
      return 'Gcc';
    default:
      return undefined;
  }
}

/**
 * Not to be used on new code: Compatibility layer to allow fetching an Environment from the deprecated containerEnvironment options.
 */
export function getEnvironmentConfigFromRing(containerEnvironment: DeploymentRing | undefined): Environment {
  switch (containerEnvironment) {
    case ContainerEnvironment.Staging: {
      return { audience: 'Staging' };
    }
    case ContainerEnvironment.Dogfood: {
      return { audience: 'Dogfood' };
    }
    case ContainerEnvironment.Prod:
    default: {
      return { audience: 'Production' };
    }
  }
}
